import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFileDoc = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 19,
	height: 19,
	viewBox: "0 0 19 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.13125 13.0227H11.2875V11.8977H6.13125V13.0227ZM6.13125 9.81641H13.7438V8.69141H6.13125V9.81641ZM6.13125 6.61016H13.7438V5.48516H6.13125V6.61016ZM4.3125 16.0039C4.0125 16.0039 3.75 15.8914 3.525 15.6664C3.3 15.4414 3.1875 15.1789 3.1875 14.8789V3.62891C3.1875 3.32891 3.3 3.06641 3.525 2.84141C3.75 2.61641 4.0125 2.50391 4.3125 2.50391H15.5625C15.8625 2.50391 16.125 2.61641 16.35 2.84141C16.575 3.06641 16.6875 3.32891 16.6875 3.62891V14.8789C16.6875 15.1789 16.575 15.4414 16.35 15.6664C16.125 15.8914 15.8625 16.0039 15.5625 16.0039H4.3125ZM4.3125 14.8789H15.5625V3.62891H4.3125V14.8789Z",
		fill: "#1D1D1D"
	})
});
export default SvgFileDoc;
